import React from 'react';
import 'bootstrap';
import 'aos';
import '../assets/css/style.css';
import '../assets/vendor/animate.css/animate.min.css';
import '../assets/vendor/aos/aos.css';
import '../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../assets/vendor/boxicons/css/boxicons.min.css';
import '../assets/vendor/glightbox/css/glightbox.min.css';
import '../assets/vendor/remixicon/remixicon.css';
import '../assets/vendor/swiper/swiper-bundle.min.css';
import lms_landing from '../assets/img/Illustrations/lms_landing.jpg';
import lms_sub_1 from '../assets/img/Illustrations/lms_sub_1.jpg';
import { Link as RouterLink } from 'react-router-dom';
import DownloadBrochure from './DownloadBrochure';
import Faq from './Faq';
import { 
    FaBookOpen, 
    FaUserCheck, 
    FaRoute, 
    FaClipboardList, 
    FaTasks, 
    FaAward, 
    FaShieldAlt, 
    FaChalkboardTeacher, 
    FaLaptopCode, 
    FaUserGraduate, 
    FaCheckCircle, 
    FaChartLine, 
    FaTable, 
    FaBell, 
    FaChartBar, 
    FaHistory, 
    FaFileAlt,
    FaBuilding,
    FaMicroscope,
    FaHospital,
    FaIndustry,
    FaLaptop,
    FaUniversity,
    FaUsers,
    FaGraduationCap,
    FaArrowRight,
    FaRobot,
    FaBrain,
    FaLanguage,
    FaMagic
} from 'react-icons/fa';

const Lms = () => {
    const keyCapabilities = [
        { icon: <FaBookOpen />, title: "Training & Course Management", desc: "Create, publish, and structure course materials effortlessly." },
        { icon: <FaUserCheck />, title: "Employee Learning Management", desc: "Track employee enrollment, progress, and skill completion." },
        { icon: <FaUserGraduate />, title: "Role-Based Training", desc: "Automatically assign courses based on role, department, and location." },
        { icon: <FaRoute />, title: "Learning Paths", desc: "Guide learners through multi-step structured learning journeys." },
        { icon: <FaClipboardList />, title: "Training Programs", desc: "Manage mandatory and optional organizational training programs." },
        { icon: <FaTasks />, title: "Assessments & Examinations", desc: "Configurable quizzes, question banks, and auto-evaluated exams." },
        { icon: <FaAward />, title: "Certification Management", desc: "Automated issue, tracking, renewal, and expiry notifications." },
        { icon: <FaChartLine />, title: "Competency Management", desc: "Define role capabilities, evaluate gaps, and foster skill growth." },
        { icon: <FaChalkboardTeacher />, title: "Instructor-Led Training", desc: "Schedule and manage live offline or online training sessions." },
        { icon: <FaLaptopCode />, title: "E-Learning", desc: "Support interactive digital courses, videos, and SCORM materials." },
        { icon: <FaCheckCircle />, title: "On-the-Job Training", desc: "Document and evaluate practical hands-on operational training." },
        { icon: <FaShieldAlt />, title: "Compliance Training", desc: "Ensure regulatory, safety, and policy compliance adherence." },
        { icon: <FaChartBar />, title: "Training Effectiveness", desc: "Measure learning outcomes and post-training job impact." },
        { icon: <FaTable />, title: "Training Matrix", desc: "Centralized matrix to monitor completion status across teams." },
        { icon: <FaBell />, title: "Notifications & Reminders", desc: "Automated alerts for upcoming, pending, or overdue activities." },
        { icon: <FaChartBar />, title: "Dashboards & Reports", desc: "Real-time L&D metrics for management, managers, and HR." },
        { icon: <FaHistory />, title: "Training History", desc: "Immutable employee learning record across their career lifecycle." },
        { icon: <FaFileAlt />, title: "Audit Trail", desc: "Comprehensive log of learning records for regulatory audits." }
    ];

    const industries = [
        { icon: <FaMicroscope />, title: "Pharmaceutical & Life Sciences", desc: "GxP, SOP compliance, quality standards, and audit readiness." },
        { icon: <FaHospital />, title: "Healthcare", desc: "Clinical procedures, patient safety protocols, and certifications." },
        { icon: <FaIndustry />, title: "Manufacturing", desc: "Operational safety, ISO compliance, and equipment operation training." },
        { icon: <FaLaptop />, title: "IT & Technology", desc: "Technical upskilling, cybersecurity compliance, and certifications." },
        { icon: <FaUniversity />, title: "Education & Academia", desc: "Structured student programs, online courses, and examinations." },
        { icon: <FaBuilding />, title: "Corporate Organizations", desc: "Onboarding, leadership, governance, and professional development." },
        { icon: <FaUsers />, title: "Research & Laboratories", desc: "Laboratory safety, technical practices, and competency tracking." }
    ];

    const aiFeatures = [
        { 
            icon: <FaRobot />, 
            title: "AI Course & Quiz Creator", 
            desc: "Upload SOPs, manuals, or documents—AI automatically extracts key learning goals, structures course modules, and generates randomized quizzes with answer keys." 
        },
        { 
            icon: <FaBrain />, 
            title: "Intelligent Skill Gap Analyzer", 
            desc: "AI algorithms evaluate employee job requirements against quiz performance to identify individual and departmental training gaps before audits." 
        },
        { 
            icon: <FaRoute />, 
            title: "Adaptive Learning Paths", 
            desc: "Personalized learning journeys that dynamically adapt to employee learning speed, performance scores, and role upgrades." 
        },
        { 
            icon: <FaMagic />, 
            title: "AI Exam Evaluation & Feedback", 
            desc: "Automated evaluation of text assessments with instant contextual explanation hints, review suggestions, and trainer feedback." 
        },
        { 
            icon: <FaBell />, 
            title: "Predictive Recertification Alerts", 
            desc: "Proactive AI notifications that predict upcoming compliance expirations and schedule re-training sessions around employee shift patterns." 
        },
        { 
            icon: <FaLanguage />, 
            title: "Multilingual AI Content Translator", 
            desc: "Instant translation of course slides, transcripts, and quizzes into 30+ global languages preserving technical GxP terminology." 
        }
    ];

    return (
        <div className='portifoliobody'>
            <main id="main">
                <section id="LMS" className="about text-start" style={{ paddingTop: '60px' }}>
                    {/* Hero Section */}
                    <div className='landing-page' style={{ padding: '30px 40px 40px 40px', minHeight: 'auto' }}>
                        <div className="container-fluid p-0">
                            <div className="row align-items-center g-4">
                                <div className="col-12 col-lg-6 animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                                    <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 rounded-pill fw-semibold mb-3 d-inline-flex align-items-center" style={{ backgroundColor: '#e7f1ff', color: '#0d6efd', fontSize: '13px' }}>
                                        <FaRobot className="me-2" /> Centralized AI-Powered Enterprise Learning & Competency Platform
                                    </span>
                                    <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#04346f' }}>Lab Iconics LMS – Empowering People Through Smarter Learning</h1>
                                    <div>
                                        <p className="lead fw-bold mb-2" style={{ color: '#04346f', fontSize: '18px' }}>
                                            From Learning to Competency — All in One AI Platform.
                                        </p>
                                        <p style={{ fontSize: '14.5px', lineHeight: '1.6', color: '#555' }}>
                                            Lab Iconics LMS is an AI-powered Learning Management System designed to help organizations manage employee learning, AI course creation, training, assessments, certifications, and competency development through a single, centralized platform.
                                        </p>
                                    </div>
                                    <div className="d-flex align-items-center gap-3 mt-3 flex-wrap">
                                        <RouterLink to='/demo'>
                                            <button className="book_a_demo_btn product-demo-btn m-0" style={{ height: '44px', padding: '0 26px' }}>Get a Demo</button>
                                        </RouterLink>
                                        <a href="#ai-intelligence" className="btn btn-outline-primary rounded-pill px-4 fw-semibold d-inline-flex align-items-center" style={{ borderColor: '#0d6efd', color: '#0d6efd', fontSize: '14px', height: '44px' }}>
                                            Explore AI Features <FaArrowRight className="ms-2" style={{ fontSize: '12px' }} />
                                        </a>
                                    </div>

                                    {/* Micro Highlight Badges Grid */}
                                    <div className="row g-2 mt-3 pt-1">
                                        <div className="col-6">
                                            <div className="p-2 rounded-3 d-flex align-items-center" style={{ backgroundColor: 'rgba(13, 110, 253, 0.06)', border: '1px solid rgba(13, 110, 253, 0.15)' }}>
                                                <div className="rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{ width: '34px', height: '34px', backgroundColor: '#0d6efd', color: '#fff', fontSize: '13px' }}>
                                                    <FaBookOpen />
                                                </div>
                                                <div>
                                                    <div className="fw-bold" style={{ fontSize: '12.5px', color: '#04346f', lineHeight: '1.2' }}>Training Matrix</div>
                                                    <div className="text-muted" style={{ fontSize: '11px', lineHeight: '1.2' }}>Automated assignment</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="p-2 rounded-3 d-flex align-items-center" style={{ backgroundColor: 'rgba(111, 66, 193, 0.06)', border: '1px solid rgba(111, 66, 193, 0.15)' }}>
                                                <div className="rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{ width: '34px', height: '34px', backgroundColor: '#6f42c1', color: '#fff', fontSize: '13px' }}>
                                                    <FaRobot />
                                                </div>
                                                <div>
                                                    <div className="fw-bold" style={{ fontSize: '12.5px', color: '#04346f', lineHeight: '1.2' }}>AI Learning Engine</div>
                                                    <div className="text-muted" style={{ fontSize: '11px', lineHeight: '1.2' }}>Auto SOP quiz & course gen</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="p-2 rounded-3 d-flex align-items-center" style={{ backgroundColor: 'rgba(25, 135, 84, 0.06)', border: '1px solid rgba(25, 135, 84, 0.15)' }}>
                                                <div className="rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{ width: '34px', height: '34px', backgroundColor: '#198754', color: '#fff', fontSize: '13px' }}>
                                                    <FaShieldAlt />
                                                </div>
                                                <div>
                                                    <div className="fw-bold" style={{ fontSize: '12.5px', color: '#04346f', lineHeight: '1.2' }}>21 CFR Part 11</div>
                                                    <div className="text-muted" style={{ fontSize: '11px', lineHeight: '1.2' }}>Audit trails & records</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="p-2 rounded-3 d-flex align-items-center" style={{ backgroundColor: 'rgba(13, 202, 240, 0.06)', border: '1px solid rgba(13, 202, 240, 0.15)' }}>
                                                <div className="rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{ width: '34px', height: '34px', backgroundColor: '#0dcaf0', color: '#fff', fontSize: '13px' }}>
                                                    <FaUserCheck />
                                                </div>
                                                <div>
                                                    <div className="fw-bold" style={{ fontSize: '12.5px', color: '#04346f', lineHeight: '1.2' }}>Competency Proof</div>
                                                    <div className="text-muted" style={{ fontSize: '11px', lineHeight: '1.2' }}>Job-role readiness</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-lg-6 text-center animate__animated animate__fadeInRight" data-aos="fade-right" data-aos-delay="100">
                                    <img src={lms_landing} alt="Lab Iconics LMS Landing" style={{ maxWidth: '100%', maxHeight: '460px', height: 'auto', borderRadius: '16px' }} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 1: Overview & Key Capabilities */}
                    <div className="container my-5 py-4">
                        <div className="text-center mb-5" data-aos="zoom-out">
                            <span className="badge bg-light text-primary border px-3 py-2 rounded-pill fw-bold text-uppercase mb-2" style={{ letterSpacing: '1px' }}>
                                Core Capabilities
                            </span>
                            <h2 style={{ color: '#04346f', fontWeight: 'bold', fontSize: '2.2rem', lineHeight: '1.3' }}>One Platform for Complete Learning Management</h2>
                            <p className="mx-auto mt-3 text-secondary" style={{ maxWidth: '800px', fontSize: '16px', lineHeight: '1.6' }}>
                                Lab Iconics LMS helps organizations plan, deliver, track, and measure learning across employees, departments, teams, and locations. From onboarding to specialized compliance, drive a culture of continuous learning.
                            </p>
                        </div>

                        <div className="row g-4 mt-3">
                            {keyCapabilities.map((cap, idx) => (
                                <div key={idx} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={30 * (idx % 6)}>
                                    <div className="p-4 h-100 bg-white rounded-3 shadow-sm border border-light d-flex align-items-start transition-all" style={{ borderLeft: '4px solid #04346f' }}>
                                        <div className="p-2 rounded-circle me-3 d-flex align-items-center justify-content-center flex-shrink-0" style={{ backgroundColor: '#e7f1ff', color: '#04346f', width: '42px', height: '42px' }}>
                                            <div className="fs-5">{cap.icon}</div>
                                        </div>
                                        <div>
                                            <h5 className="mb-2 fw-bold" style={{ color: '#04346f', fontSize: '1.05rem' }}>{cap.title}</h5>
                                            <p className="text-secondary mb-0 small" style={{ lineHeight: '1.5', fontSize: '13.5px' }}>{cap.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* AI-Powered LMS Intelligence Section */}
                    <div id="ai-intelligence" className="py-5" style={{ background: 'linear-gradient(135deg, #031e42 0%, #04346f 50%, #0a4f9e 100%)', color: '#fff' }}>
                        <div className="container">
                            <div className="text-center mb-5" data-aos="zoom-in">
                                <span className="badge bg-info text-dark px-3 py-2 rounded-pill fw-bold text-uppercase mb-2" style={{ letterSpacing: '1px' }}>
                                    <FaRobot className="me-1" /> Next-Gen AI Technology
                                </span>
                                <h2 style={{ color: '#fff', fontWeight: 'bold', fontSize: '2.4rem', lineHeight: '1.3' }}>
                                    AI-Powered Learning & Competency Intelligence
                                </h2>
                                <p className="mx-auto mt-3 text-light opacity-75" style={{ maxWidth: '850px', fontSize: '16px', lineHeight: '1.6' }}>
                                    Transform how your organization creates content, assesses skills, and enforces compliance. Lab Iconics LMS uses AI automation to eliminate manual training overhead and ensure continuous workforce readiness.
                                </p>

                                {/* AI Prompt Chips */}
                                <div className="d-flex flex-wrap justify-content-center gap-2 mt-4">
                                    <span className="badge bg-white bg-opacity-10 text-white border border-white border-opacity-25 px-3 py-2 rounded-pill font-monospace" style={{ fontSize: '12.5px' }}>
                                        🤖 "Auto-generate quiz & course from SOP PDF"
                                    </span>
                                    <span className="badge bg-white bg-opacity-10 text-white border border-white border-opacity-25 px-3 py-2 rounded-pill font-monospace" style={{ fontSize: '12.5px' }}>
                                        📊 "Analyze QA team skill gaps before audit"
                                    </span>
                                    <span className="badge bg-white bg-opacity-10 text-white border border-white border-opacity-25 px-3 py-2 rounded-pill font-monospace" style={{ fontSize: '12.5px' }}>
                                        🎯 "Personalize onboarding track for Lab Tech"
                                    </span>
                                </div>
                            </div>

                            <div className="row g-4 mt-2">
                                {aiFeatures.map((feature, idx) => (
                                    <div key={idx} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={40 * idx}>
                                        <div className="p-4 h-100 rounded-3 border transition-all" style={{ backgroundColor: 'rgba(255, 255, 255, 0.05)', borderColor: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(10px)' }}>
                                            <div className="p-3 rounded-circle me-3 mb-3 d-inline-flex align-items-center justify-content-center" style={{ backgroundColor: '#0dcaf0', color: '#031e42', width: '48px', height: '48px', fontSize: '20px' }}>
                                                {feature.icon}
                                            </div>
                                            <h5 className="fw-bold mb-2 text-white" style={{ fontSize: '1.15rem' }}>{feature.title}</h5>
                                            <p className="text-light opacity-75 mb-0" style={{ fontSize: '13.5px', lineHeight: '1.6' }}>{feature.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Section 2: Deep Dive Features (Content & Role-Based Learning) */}
                    <div className="section-container" style={{ margin: '0px', backgroundColor: '#f8f9fa' }}>
                        <div className="row">
                            <div className="section-pro">
                                <div className="sec-out">
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                        <img src={lms_sub_1} alt="Role-based LMS training" style={{ width: '100%', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.08)' }} />
                                    </div>
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title">
                                            <h1>Create, Manage & Deliver Role-Based Learning</h1>
                                        </div>
                                        <p className="mb-3 text-secondary">
                                            Create structured learning programs tailored to your organization’s unique goals. Deliver the right training to the right employee at the right time.
                                        </p>
                                        <ul className="sec-ul">
                                            <li><b>Diverse Content Formats – </b> Documents, Videos, Presentations, Online courses, Assessments, Question banks, and SCORM modules.</li>
                                            <li><b>Flexible Configurations – </b> Configure requirements by job role, designation, department, location, experience, and competencies.</li>
                                            <li><b>Structured Learning Paths – </b> Map employee journeys: <i>New Employee → Induction → Role Training → Skill Development → Assessment → Certification</i>.</li>
                                            <li><b>End-to-End Training Management – </b> Plan, assign, learn, assess, complete, certify, and evaluate with full automation.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 3: Assessment, Competency & Compliance */}
                    <div className="container my-5 py-4">
                        <div className="row g-4">
                            <div className="col-lg-6" data-aos="fade-right">
                                <div className="p-4 bg-white rounded-3 shadow-sm h-100 border border-light" style={{ borderLeft: '5px solid #04346f' }}>
                                    <h3 style={{ color: '#04346f', fontWeight: 'bold' }} className="mb-3 d-flex align-items-center">
                                        <FaTasks className="me-2 text-primary" /> Assessments & Examinations
                                    </h3>
                                    <p className="text-secondary small mb-3">
                                        Measure knowledge and learning outcomes with highly configurable assessment tools:
                                    </p>
                                    <ul className="lh-lg text-secondary small ps-3">
                                        <li>Multiple-choice, True/False, and multi-select questions</li>
                                        <li>Centralized Question Banks & randomized question selection</li>
                                        <li>Configurable passing thresholds and attempt limits</li>
                                        <li>Automatic evaluation, instant feedback, and historic trend analysis</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-6" data-aos="fade-left">
                                <div className="p-4 bg-white rounded-3 shadow-sm h-100 border border-light" style={{ borderLeft: '5px solid #0d6efd' }}>
                                    <h3 style={{ color: '#04346f', fontWeight: 'bold' }} className="mb-3 d-flex align-items-center">
                                        <FaShieldAlt className="me-2 text-primary" /> Compliance & Certifications
                                    </h3>
                                    <p className="text-secondary small mb-3">
                                        Ensure organizational readiness and regulatory compliance across all operating units:
                                    </p>
                                    <ul className="lh-lg text-secondary small ps-3">
                                        <li>Mandatory policy, safety, quality, and regulatory compliance programs</li>
                                        <li>Support for regulated sectors: <b>Pharma (GxP/SOP), Healthcare, Manufacturing, Labs</b></li>
                                        <li>Automated certification issuance, renewal tracking, and expiry alerts</li>
                                        <li>Complete audit trail logging for regulatory inspection readiness</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 4: Training Matrix Visual */}
                    <div className="bg-light py-5">
                        <div className="container">
                            <div className="text-center mb-4" data-aos="zoom-in">
                                <span className="badge bg-primary-subtle text-primary border px-3 py-2 rounded-pill fw-bold text-uppercase mb-2" style={{ backgroundColor: '#e7f1ff', color: '#0d6efd', letterSpacing: '1px' }}>
                                    Real-time Visibility
                                </span>
                                <h3 style={{ color: '#04346f', fontWeight: 'bold', fontSize: '2.2rem' }}>Centralized Training Matrix</h3>
                                <p className="text-secondary mx-auto" style={{ maxWidth: '750px' }}>Get an instant overview of employee training status, gaps, and renewal needs.</p>
                            </div>
                            <div className="table-responsive shadow-sm bg-white rounded-3 p-3" data-aos="fade-up">
                                <table className="table table-hover align-middle mb-0 text-center">
                                    <thead style={{ backgroundColor: '#04346f', color: '#fff' }}>
                                        <tr>
                                            <th>Training Type</th>
                                            <th>Employee Role</th>
                                            <th>Current Status</th>
                                            <th>Action Required</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="fw-semibold text-start ps-3">Onboarding & Induction</td>
                                            <td>New Hire</td>
                                            <td><span className="badge bg-info text-dark px-3 py-2 rounded-pill">Assigned</span></td>
                                            <td>Complete Modules 1-4</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-semibold text-start ps-3">SOP / Quality Compliance</td>
                                            <td>QA Analyst / Operator</td>
                                            <td><span className="badge bg-warning text-dark px-3 py-2 rounded-pill">In Progress</span></td>
                                            <td>Assessment Pending</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-semibold text-start ps-3">Information Security & Data Privacy</td>
                                            <td>All Employees</td>
                                            <td><span className="badge bg-success px-3 py-2 rounded-pill">Completed</span></td>
                                            <td>Valid (1 Year)</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-semibold text-start ps-3">Safety & Operational Certification</td>
                                            <td>Lab Lead / Engineer</td>
                                            <td><span className="badge bg-danger px-3 py-2 rounded-pill">Renewal Required</span></td>
                                            <td>Re-certification Due</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Section 5: Industry Use-cases */}
                    <div className="container my-5 py-4">
                        <div className="text-center mb-5" data-aos="zoom-out">
                            <span className="badge bg-light text-primary border px-3 py-2 rounded-pill fw-bold text-uppercase mb-2" style={{ letterSpacing: '1px' }}>
                                Industry Alignment
                            </span>
                            <h2 style={{ color: '#04346f', fontWeight: 'bold', fontSize: '2.2rem' }}>Built for Multiple Industries</h2>
                            <p className="text-secondary mx-auto" style={{ maxWidth: '750px' }}>
                                Lab Iconics LMS is engineered to support the distinct learning and compliance mandates of diverse business sectors.
                            </p>
                        </div>
                        <div className="row g-4">
                            {industries.map((ind, i) => (
                                <div key={i} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={40 * (i % 6)}>
                                    <div className="p-4 bg-white rounded-3 shadow-sm h-100 border border-light text-start transition-all" style={{ borderTop: '4px solid #04346f' }}>
                                        <div className="p-3 rounded-circle d-inline-flex mb-3 align-items-center justify-content-center" style={{ backgroundColor: '#e7f1ff', color: '#04346f', width: '50px', height: '50px' }}>
                                            <div className="fs-4">{ind.icon}</div>
                                        </div>
                                        <h5 className="fw-bold" style={{ color: '#04346f' }}>{ind.title}</h5>
                                        <p className="text-secondary small mb-0" style={{ lineHeight: '1.5' }}>{ind.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Section 6: Why Choose Lab Iconics LMS */}
                    <div className="py-5 my-4" style={{ background: 'linear-gradient(135deg, #031e42 0%, #04346f 50%, #0a4f9e 100%)', color: '#fff', borderRadius: '16px' }}>
                        <div className="container text-center py-2">
                            <span className="badge bg-warning text-dark px-3 py-2 rounded-pill fw-bold text-uppercase mb-2" style={{ letterSpacing: '1px' }}>
                                Core Value Proposition
                            </span>
                            <h2 className="fw-bold mb-4 text-white" style={{ fontSize: '2.2rem' }} data-aos="zoom-in">Why Choose Lab Iconics LMS?</h2>
                            <div className="row g-4 text-start mt-2">
                                <div className="col-md-4" data-aos="fade-up">
                                    <div className="p-4 rounded-3 h-100 border border-light border-opacity-25" style={{ background: 'rgba(255,255,255,0.06)' }}>
                                        <h5 className="text-warning fw-bold">Centralized Ecosystem</h5>
                                        <p className="small text-light opacity-75 mb-0" style={{ lineHeight: '1.6' }}>Manage your entire enterprise learning infrastructure, courses, and certifications from one unified portal.</p>
                                    </div>
                                </div>
                                <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                                    <div className="p-4 rounded-3 h-100 border border-light border-opacity-25" style={{ background: 'rgba(255,255,255,0.06)' }}>
                                        <h5 className="text-warning fw-bold">Personalized Journeys</h5>
                                        <p className="small text-light opacity-75 mb-0" style={{ lineHeight: '1.6' }}>Deliver automated training assignments customized to job roles, skills, departments, and career stages.</p>
                                    </div>
                                </div>
                                <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
                                    <div className="p-4 rounded-3 h-100 border border-light border-opacity-25" style={{ background: 'rgba(255,255,255,0.06)' }}>
                                        <h5 className="text-warning fw-bold">Measurable Development</h5>
                                        <p className="small text-light opacity-75 mb-0" style={{ lineHeight: '1.6' }}>Track learning velocity, skill gap resolution, and assessment scores with real-time L&D dashboards.</p>
                                    </div>
                                </div>
                                <div className="col-md-4" data-aos="fade-up">
                                    <div className="p-4 rounded-3 h-100 border border-light border-opacity-25" style={{ background: 'rgba(255,255,255,0.06)' }}>
                                        <h5 className="text-warning fw-bold">Automated Workflows</h5>
                                        <p className="small text-light opacity-75 mb-0" style={{ lineHeight: '1.6' }}>Eliminate manual effort with scheduled course assignments, automated email reminders, and recertification triggers.</p>
                                    </div>
                                </div>
                                <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                                    <div className="p-4 rounded-3 h-100 border border-light border-opacity-25" style={{ background: 'rgba(255,255,255,0.06)' }}>
                                        <h5 className="text-warning fw-bold">Multi-Site Scalability</h5>
                                        <p className="small text-light opacity-75 mb-0" style={{ lineHeight: '1.6' }}>Easily scale across business units, subsidiaries, global locations, and thousands of concurrent users.</p>
                                    </div>
                                </div>
                                <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
                                    <div className="p-4 rounded-3 h-100 border border-light border-opacity-25" style={{ background: 'rgba(255,255,255,0.06)' }}>
                                        <h5 className="text-warning fw-bold">Audit & Compliance Ready</h5>
                                        <p className="small text-light opacity-75 mb-0" style={{ lineHeight: '1.6' }}>Maintain tamper-proof training records, full audit trails, and instant reporting for regulatory inspections.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {/* Downloads & FAQ */}
            <div className="down-broch" data-aos="fade-up" data-aos-delay="100">
                <DownloadBrochure product={'LMS'} />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <Faq product={'LMS'} />
            </div>
        </div>
    );
};

export default Lms;

